import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { catchError, map } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { deepCamelCase } from './camel-case.util';
import { readThrottleInfo, ThrottleNotice } from './throttle-notice';

@Injectable({ providedIn: 'root' })
export class SpaqFireFunctions {
	constructor(
		private fns: AngularFireFunctions,
		private afAuth: AngularFireAuth,
		private throttleNotice: ThrottleNotice
	) {}

	httpsCallable<T = any, R = any>(name: string, options?: Parameters<AngularFireFunctions['httpsCallable']>[1]) {
		const callable = this.fns.httpsCallable<T, R>(name, options);
		return (data: T) =>
			callable(data).pipe(
				map(result => deepCamelCase(result)),
				catchError(e => {
					if (e && e.code === 'functions/unauthenticated') {
						this.afAuth.signOut().then(() => (window.location.href = '/'));
					}
					if (e && e.code === 'functions/resource-exhausted') {
						this.throttleNotice.show(readThrottleInfo(e));
					}
					return throwError(e);
				})
			);
	}
}
